<!-- #1 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Allocation Rules
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        dark
        small
        class="float-right mr-5"
        @click="addLinehaul()"
        v-if="checkPermission('app_linehaul:linehaul_post')"
      >
        Add Allocation Rules
      </v-btn>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-dialog
      v-model="detailsDialog"
      max-width="550px"
      close-delay="ma-5"
      @keydown.esc="detailsDialog = false"
    >
      <v-card class="px-0">
        <v-card-title class="pb-2">
          <span class="text-h5">{{ title }} </span>
          <v-spacer></v-spacer>
          <v-icon @click="detailsDialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-0">
          <v-card-text>
            <ul>
              <li v-for="list in detailsData" :key="list">{{ list }}</li>
            </ul>
          </v-card-text>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="linehaul"
      :options.sync="options"
      :server-items-length="total"
      :loading="linehaulLoader"
      class="elevation-1 mt-7 mr-4"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <ConfirmDialog
            :dialog="dialogDelete"
            text="Are you sure you want to delete this item?"
            :loader="deleteLoader"
            @confirm="deleteItemConfirm"
            @close="closeDelete"
          />
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="client_name"
                  :items="clients"
                  outlined
                  dense
                  chips
                  item-text="name"
                  item-value="id"
                  small-chips
                  label="Client name"
                  clearable
                  @click:clear="clearInput('this.client_name')"
                  @focus="fetchClients"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="carrier"
                  :items="carriers"
                  outlined
                  dense
                  chips
                  item-text="name"
                  item-value="id"
                  small-chips
                  label="Carrier name"
                  clearable
                  @click:clear="clearInput('this.carrier')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="origin"
                  :items="countries"
                  outlined
                  dense
                  chips
                  item-text="name"
                  item-value="id"
                  small-chips
                  label="Origin"
                  clearable
                  @click:clear="clearInput('this.origin')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="status"
                  :items="statuses"
                  outlined
                  item-text="text"
                  item-value="value"
                  small-chips
                  label="Status"
                  clearable
                  @click:clear="clearInput('this.status')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="destination"
                  :items="countries"
                  outlined
                  dense
                  chips
                  item-text="name"
                  item-value="id"
                  small-chips
                  label="Destination"
                  clearable
                  @input="callApis"
                  @click:clear="clearInput('this.destination')"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" md="3" v-if="destination">
                <v-autocomplete
                  v-model="citiesArray"
                  :items="citiesArr"
                  outlined
                  dense
                  chips
                  item-text="name"
                  item-value="id"
                  small-chips
                  label="Cities"
                  multiple
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" md="3" v-if="destination">
                <v-autocomplete
                  v-model="areaArray"
                  :items="areaArr"
                  outlined
                  dense
                  chips
                  item-text="name"
                  item-value="id"
                  small-chips
                  label="Area"
                  multiple
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" md="3" v-if="destination">
                <v-autocomplete
                  label="Pincode"
                  :items="pincodeArr"
                  v-model="pincodeArray"
                  item-value="id"
                  item-text="pincode"
                  outlined
                  multiple
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  label="Payment Mode"
                  :items="paymentModes"
                  v-model="payment_type"
                  item-value="value"
                  item-text="text"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="delivery_Type"
                  :items="deliveryTypes"
                  outlined
                  item-text="text"
                  item-value="value"
                  small-chips
                  label="Delivery Type"
                  @input="getService(delivery_Type)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="duty_handling"
                  :items="dutyhandlings"
                  outlined
                  item-text="text"
                  item-value="value"
                  small-chips
                  label="Duty Handling"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="userCategory.user_category === 3 && delivery_Type"
              >
                <v-autocomplete
                  v-model="service_type"
                  :items="servicesTypes"
                  outlined
                  :item-text="
                    (item) => `${item.service_name} - (${item.service_code})`
                  "
                  item-value="service_code"
                  small-chips
                  label="Service Type"
                ></v-autocomplete>
              </v-col>
              <v-col
                :cols="
                  destination && delivery_Type
                    ? 12
                    : destination
                    ? 3
                    : delivery_Type
                    ? 9
                    : 12
                "
                class="text-end pr-4 mb-2"
              >
                <v-btn class="success" color="primary" @click="searchAll"
                  >Search</v-btn
                >
                <v-btn color="white" class="ml-4" @click="allClear"
                  >Clear</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="mb-2 mt-2"></v-divider>
        </template>
      </template>
      <template v-slot:[`item.client`]="{ item }">
        {{ item.client_id_name }}
      </template>
      <template v-slot:[`item.duty_handling`]="{ item }">
        <span v-if="item.duty_handling">{{
          item.duty_handling.toUpperCase()
        }}</span>
      </template>

      <template v-slot:[`item.carrier`]="{ item }">
        <label
          ><strong>Last Mile:</strong>
          <span v-if="item.carrier.length == 0"> - </span>
          <span v-else>{{ filterValue(item.carrier) }}</span>
        </label>
        <br />
        <!-- <label
          ><strong>Transit Partner:</strong>
          <span v-if="item.transit_partner.name.length == 0"> - </span>
          <span v-else>{{ item.transit_partner.name.toString() }}</span>
        </label> -->
      </template>
      <template v-slot:[`item.origin_country`]="{ item }">
        <div class="align-center">
          <img
            :src="getImage(item.origin_country_id_flag)"
            :alt="item.origin_country_id_flag"
            class="ma-3 country-logo pb-0 mb-0 ml-0 pl-0"
          />
          <span class="pt-0"> {{ item.origin_country_id_name }}</span>
          <!-- <span class="text-uppercase">{{ item.origin_country.code }}</span> -->
        </div>
      </template>
      <template v-slot:[`item.destination_country`]="{ item }">
        <div class="align-center">
          <img
            :src="getImage(item.destination_country_id_flag)"
            :alt="item.destination_country_id_name"
            class="ma-3 country-logo pb-0 mb-0 ml-0 pl-0"
          />
          <span>{{ item.destination_country_id_name }}</span>
          <!-- <span class="text-uppercase">{{
            item.destination_country.code
          }}</span> -->
        </div>
      </template>
      <template v-slot:[`item.create_date`]="{ item }">
        {{ item.create_date | moment("DD MMM, YYYY hh:mm A") }}
      </template>
      <template v-slot:[`item.write_date`]="{ item }">
        {{ item.write_date | moment("DD MMM, YYYY hh:mm A") }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-switch
          v-model="item.status"
          @change="confirmStatusChange(item)"
          v-if="
            checkPermission('app_linehaul:linehaul_mark_inactive') &&
            item.status == true
          "
        ></v-switch>
        <v-switch
          v-model="item.status"
          @change="confirmStatusChange(item)"
          v-else-if="confirmStatusopen == true"
        ></v-switch>
        <span v-else :class="item.status == true ? 'badge-active' : 'badge'"
          >{{ item.status == true ? "Active" : "In-active" }}
        </span>
      </template>
      <template
        v-slot:[`item.actions`]="{ item }"
        v-if="checkPermission('app_linehaul:linehaul_carrier_list_edit')"
      >
        <v-icon small class="mr-2" @click="editLinehaul(item)">
          mdi-pencil
        </v-icon>
      </template>
      <template v-slot:[`item.coverage`]="{ item }">
        <v-tooltip bottom v-if="item.destination_city_ids">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="cityList(item, 1)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-city
            </v-icon>
          </template>
          <span>City</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.destination_area_ids">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="cityList(item, 2)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-download
            </v-icon>
          </template>
          <span>Area</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.destination_pincode_ids">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="cityList(item, 3)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-map-marker
            </v-icon>
          </template>
          <span>Pincode</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="dialogConfirm"
      text="Are you sure want to change status?"
      :loader="linehaulLoader"
      @confirm="changeStatus"
      @close="closeConfirm"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";

export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    title: "",
    pincodeArr: [],
    pincodeArray: [],
    citiesArr: [],
    citiesArray: [],
    areaArr: [],
    areaArray: [],
    paymentModes: [
      {
        text: "COD",
        value: "COD",
      },
      {
        text: "Prepaid",
        value: "Prepaid",
      },
      {
        text: "COD & Prepaid",
        value: "COD,Prepaid",
      },
    ],
    detailsDialog: false,
    dialogDelete: false,
    status: null,
    delivery_Type: null,
    duty_handling: null,
    service_type: null,
    deliveryTypes: [
      { text: "Cross Border", value: "crossborder" },
      { text: "Domestic", value: "domestic" },
    ],
    dutyhandlings: [
      { text: "DDU", value: "ddu" },
      { text: "DDP", value: "ddp" },
    ],
    servicesTypes: [],
    statuses: [
      {
        text: "Active",
        value: "True",
      },
      {
        text: "Inactive",
        value: "False",
      },
    ],
    headers: [
      {
        text: "Client Name",
        value: "client",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Carrier Name",
        value: "carrier",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Origin",
        value: "origin_country",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: 120,
      },
      {
        text: "Destination",
        value: "destination_country",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: 100,
      },

      {
        text: "Payment Type",
        value: "service_payment_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Delivery Type",
        value: "delivery_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Duty Handling",
        value: "duty_handling",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Service Type",
        value: "service_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created At",
        value: "create_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created By",
        value: "created_by",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated At",
        value: "write_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Updated By",
        value: "modified_by",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Coverage",
        value: "coverage",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
    ],
    payment_type: null,
    linehaul: [],
    options: {},
    total: 1,
    linehaulLoader: false,
    editedIndex: -1,
    search: null,
    deleteLoader: false,
    _timerId: null,
    countries: [],
    origin: null,
    destination: null,
    carrier: null,
    carriers: [],
    clients: [],
    filtersArr: {},
    client_name: "",
    dialogConfirm: false,
    detailsData: [],
    confirmStatusopen: false,
  }),

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    options: {
      handler() {
        this.fetchLineHaulList();
      },
      deep: true,
    },
    search() {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        this.fetchLineHaulList();
      }, 300);
    },
  },
  created() {
    this.fetchCarriers();
    this.getCountryList();
    this.fetchClients();
    if (this.$route.params.id) {
      this.client_name = this.$route.params.id;
      this.allFilters();
    }
  },
  computed: {
    ...mapGetters(["userCategory"]),
  },
  methods: {
    ...mapActions([
      "getLinehaulList",
      "deleteLinehaulUIData",
      "snackBar",
      "getCountries",
      "getCarriersDropdown",
      "fetchClient",
      "updateLinehaulStatus",
      "linehaulcities",
      "linehaulareas",
      "linehaulpincode",
      "linehaulCityList",
      "getRSAServiceListOnly",
    ]),
    getService(service) {
      if (this.userCategory.user_category === 3) {
        service = Array.isArray(service) ? service.join(",") : service;
        this.getRSAServiceListOnly(service).then((res) => {
          this.servicesTypes = res.data;
        });
      }
    },
    cityList(item, type) {
      if (type == 1) {
        this.title = "City List";
      } else if (type == 2) {
        this.title = "Area List";
      } else if (type == 3) {
        this.title = "Pincode";
      }
      let payload = {
        id: item.id,
        type: type,
      };
      this.linehaulCityList(payload).then((res) => {
        this.detailsData = res.data.result[0];
        this.detailsDialog = true;
      });
    },
    filterValue(carrier) {
      let filteredCarrier = carrier
        .filter((item) => item !== null && item !== undefined)
        .map((item) => (typeof item === "string" ? `${item}` : item));

      // Convert the filtered array to a comma-separated string
      let result = filteredCarrier.join(", ");

      return result;
    },
    callApis() {
      if (this.destination) {
        let index = this.countries.findIndex((e) => e.id == this.destination);
        let id = this.countries[index].code;
        this.linehaulcities(id).then((res) => {
          this.citiesArr = res.data;
        });
        this.linehaulareas({
          id: id,
        }).then((res) => {
          this.areaArr = res.data;
        });

        this.linehaulpincode(this.destination).then((res) => {
          this.pincodeArr = res.data.records;
        });
      } else {
        this.destination = null;
        this.areaArray = [];
        this.pincodeArray = [];
        this.citiesArray = [];
      }
    },
    confirmStatusChange(item) {
      this.confirmStatusopen = true;
      this.editedIndex = this.linehaul.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogConfirm = true;
    },
    closeConfirm() {
      this.dialogConfirm = false;
      this.linehaul[this.editedIndex].status = this.linehaul[this.editedIndex]
        .status
        ? false
        : true;
      this.reset();
      this.confirmStatusopen = false;
    },

    changeStatus() {
      this.linehaulLoader = true;
      this.confirmStatusopen = false;

      this.updateLinehaulStatus({
        id: this.editedItem.id,
        data: this.editedItem,
      })
        .then((res) => {
          this.linehaulLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialogConfirm = false;
          this.reset();
          this.fetchLineHaulList();
        })
        .catch(() => {
          this.linehaulLoader = false;
          this.closeConfirm();
        });
    },
    reset() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form?.reset();
      });
    },
    fetchClients() {
      if (this.clients.length > 0) return;
      this.fetchClient({
        service: "clickdna,fulfillment_wid_last_mile",
      }).then((res) => {
        this.clients = res.data;
      });
    },
    fetchCarriers() {
      this.getCarriersDropdown({
        pagination: 0,
      })
        .then((res) => {
          this.carriers = res.data;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getCountryList() {
      this.getCountries().then((res) => {
        this.countries = res.data;
      });
    },
    fetchLineHaulList() {
      this.linehaul = [];
      this.linehaulLoader = true;
      let payload = {};
      if (this.$route.query.carrier_id !== undefined) {
        payload = {
          ...this.filtersArr,
          ...this.options,
          search: this.search,
          carrier_id: this.$route.query.carrier_id,
        };
      } else {
        payload = {
          ...this.filtersArr,
          ...this.options,
          search: this.search,
        };
      }
      this.getLinehaulList(payload)
        .then((res) => {
          this.linehaulLoader = false;
          this.linehaul = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.linehaulLoader = false;
        });
    },
    addLinehaul() {
      this.$router.push({
        name: "LinehaulAdd",
        params: {
          id: 0,
        },
      });
    },

    editLinehaul(item) {
      this.$router.push({
        name: "LinehaulEdit",
        params: {
          client_id: item.client_id,
          origin: item.origin_country_id,
          destination: item.destination_country_id,
          duty_handling: item.duty_handling,
          delivery_type: item.delivery_type,
          id: item.id,
        },
      });
    },

    deleteItem(item) {
      this.editedIndex = this.linehaul.indexOf(item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.deleteLoader = true;
      this.deleteLinehaulUIData(this.linehaul[this.editedIndex].id)
        .then((res) => {
          this.deleteLoader = false;
          this.linehaul.splice(this.editedIndex, 1);
          this.closeDelete();
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.fetchLineHaulList();
        })
        .catch(() => {
          this.deleteLoader = false;
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },

    getImage(url) {
      return "/images/flags/" + url.split("/").pop();
    },
    allFilters() {
      var cityString = [];

      if (this.citiesArray.length > 0) {
        cityString = this.citiesArray.join(",");
      } else {
        cityString = this.citiesArray;
      }
      var areaString = [];

      if (this.areaArray.length > 0) {
        areaString = this.areaArray.join(",");
      } else {
        areaString = this.areaArray;
      }
      var pinString = [];

      if (this.pincodeArray.length > 0) {
        pinString = this.pincodeArray.join(",");
      } else {
        pinString = this.pincodeArray;
      }

      let obj = {
        client_id: this.client_name,
        carrier_id: this.carrier,
        origin_country_id: this.origin,
        destination_country_id: this.destination,
        status: this.status,
        delivery_type: this.delivery_Type,
        duty_handling: this.duty_handling,
        payment_type: this.payment_type,
        area: areaString,
        city: cityString,
        pincode: pinString,
        service_type: this.delivery_Type ? this.service_type : "",
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.linehaulLoader = true;
      this.getLinehaulList({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.linehaulLoader = false;
          this.linehaul = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.linehaulLoader = false;
        });
    },
    allClear() {
      this.client_name = "";
      this.carrier = "";
      this.origin = "";
      this.destination = "";
      this.status = null;
      this.delivery_Type = null;
      this.duty_handling = null;
      this.payment_type = null;
      this.areaArray = [];
      this.pincodeArray = [];
      this.citiesArray = [];
      this.service_type = null;
      this.searchAll();
    },
    clearInput(val) {
      if (val != null) {
        val = null;
      }
    },
  },
};
</script>
<style>
.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
